import React, { forwardRef, InputHTMLAttributes, useEffect, useState } from 'react';
import './InputSocialSecurity.css';
import InputBase from '../InputBase';
import { IInputProps } from '../InputBase/InputBase';
import { createProgressiveMask } from '../../utils/utils';
interface IInputSocialSecurityProps extends IInputProps {
	className?: string;
	value: string;
	setValue: (ssn: string) => void;
	lastFour?: boolean;
}

const InputSocialSecurity = forwardRef(
	(
		{
			className = '',
			value = '',
			setValue,
			lastFour = false,
			onFocus,
			onBlur,
			type = 'tel',
			...rest
		}: IInputSocialSecurityProps & InputHTMLAttributes<any>,
		ref: any,
	) => {
		const getRawVal = (val) => val?.replace(/[^0-9]/g, '');
		const isSsnValid = (val) => getRawVal(val)?.length === (lastFour ? 4 : 9);

		const [isVisible, setIsVisible] = useState(false);
		const mask = lastFour ? 'XXXX' : 'XXX-XX-XXXX';
		const [maskObjects, setMaskObjects]=useState(createProgressiveMask(mask, '0', isVisible ? undefined : '*', ['-']))


		useEffect(()=>{
			setMaskObjects(createProgressiveMask(mask, '0', isVisible ? undefined : '*', ['-']));
        },[isVisible])

		return (
			<InputBase
				{...rest}
				autoComplete='off'
				type='tel'
				mask={maskObjects}
				eager={true}
				lazy={false}
				isVisible={isVisible}
				setIsVisible={setIsVisible}
				className={`InputSocialSecurity ${className}`}
				value={value}
				ref={ref}
				minLength={0}
				maxLength={lastFour ? 4 : 11}
				isValid={isSsnValid}
				onBlur={(e: React.FocusEvent<HTMLInputElement>)=>{
                    onBlur && onBlur(e);
                }}
				onFocus={(e: React.FocusEvent<HTMLInputElement>)=> {
                    onFocus && onFocus(e);
                }}
				setValue={setValue}
			/>
		)
	},
);

InputSocialSecurity.displayName = 'InputSocialSecurity';

export default InputSocialSecurity;
